import styled from 'styled-components'
import { Button } from '../../styles'
import { DEFAULT, PRODUCT_PAGE } from '../../../constants/constants'

export const CTA = styled(Button)<{
  applicationMode: any
  $insideSummaryPanel: any
}>`
  ${(props) => (props.applicationMode === PRODUCT_PAGE || props.$insideSummaryPanel) && 'width: 100%;'};
  ${(props) => (props.applicationMode === PRODUCT_PAGE || props.$insideSummaryPanel) && 'margin-top: 0 !important;'};

  @media (max-width: 767px) {
    ${(props) => props.applicationMode === DEFAULT && 'padding-right: 15px'};
    ${(props) => props.applicationMode === DEFAULT && 'padding-left: 15px'};
  }

  @media (min-width: 1200px) {
    ${(props) => props.applicationMode === PRODUCT_PAGE && 'width: 70%;'};
    ${(props) => props.applicationMode === PRODUCT_PAGE && 'min-width: 475px;'};
    ${(props) => props.applicationMode === PRODUCT_PAGE && 'align-self: flex-end;'};
  }

  i {
    ${(props) => props.applicationMode === DEFAULT && 'font-size: 24px;'}

    @media (min-width: 768px) {
      ${(props) => props.applicationMode === DEFAULT && 'display: none;'}
    }
  }

  .button-text {
    @media (max-width: 767px) {
      ${(props) => props.applicationMode === DEFAULT && !props.$insideSummaryPanel && 'display: none;'}
    }
  }
`

const MODAL_MAX_WIDTH = '550px'

export const ModalAddToCart = styled.div`
  max-width: ${MODAL_MAX_WIDTH};
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;

  @media (min-width: 768px) {
    padding: 5px 15px;
  }

  ul {
    @media (min-width: 1200px) {
      margin-bottom: 25px;
    }
  }

  p {
    width: 100%;
  }
`

export const UnavailableArticlesList = styled.ul`
  width: 100%;
  list-style: none;
  margin: 0 0 20px;
  padding: 0;

  li {
    padding: 4px 0;
  }
`
